import { Navigate } from "react-router-dom";
import { useIsOrganizer } from "@/hooks/useIsOrganizer";
import { Loader2 } from "lucide-react";

interface ProtectedOrganizerRouteProps {
  children: React.ReactNode;
}

const ProtectedOrganizerRoute = ({ children }: ProtectedOrganizerRouteProps) => {
  const { data: isOrganizer, isLoading } = useIsOrganizer();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isOrganizer) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedOrganizerRoute;
